import React from "react";
import { useSelector } from "react-redux";
import { AiOutlineClose } from "react-icons/ai";
import { useHistory } from "react-router-dom";
import "../onboarding.css";
import Body from "./Body";

export default function VerifyProfile() {
  const history = useHistory();
  const { profile } = useSelector(({ studentReducer }) => ({
    profile: studentReducer,
  }));

  function isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
  }

  if (isObjectEmpty(profile.userData)) {
    history.push("/login");
  }

  const next = () => {
    history.push("/onboarding/complete-profile");
  };

  return (
    <div className="flex flex-column justify-center">
      <div className="App-height py-3 px-2 md:w-1/3">
        <div>
          <AiOutlineClose
            size={25}
            className="mt-5"
            onClick={() => history.goBack()}
          />
          <h1 className="a_acc_header mt-2">Verify your profile</h1>
          <p className="a_acc_header_text">
            If this is you click next to complete your verification process
          </p>
        </div>
        <div>
          <Body
            profile={profile.userData}
            loadingStatus={profile.activateUserLoading}
          />
          <div className="text-center mb-10 mt-10">
            <button className="a_acc_btn" onClick={next}>
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
